import React from "react";

const SidebarIcon = ({ iconName }) => (
    <div className={`menu--icon ${iconName}`}></div>
);

export default SidebarIcon;
